import i18n from '@/plugins/i18n';
import * as types from './mutations-type.js';
import StorageTypesService from "../../../../services/StorageTypesService";

export default {
    loadingON({commit}) {
        commit(types.SET_LOADING_ON, true);
    },
    loadingOFF({commit}) {
        commit(types.SET_LOADING_OFF, false);
    },
    // TODO: Decir a Osvaldo que implemente filtro para storageDeviceType
    async fetchAllStorageTypesByCompany({dispatch, commit, state}, [filter, toast]) {
        dispatch('loadingON');
        try {
            state.storagesTypesByCompany = [];
            const {data} = await StorageTypesService.storageTypesByCompany(filter);
            commit(types.SET_STORAGE_TYPE_BY_COMPANY, data);
            dispatch('loadingOFF');
        } catch (error) {
            if (error.message !== 'cancelRequest')
                toast.error(i18n.t('storageType.notification.listError'), {
                    queueable: true
                });
        }
    },
    async fetchStorageTypesByCompanyAccess({dispatch, commit, state}, [toast]) {
        dispatch('loadingON');
        try {
            state.storageDeviceTypesByCompanyAccess = [];
            const {data} = await StorageTypesService.storageTypesByCompanyAccess();
            commit(types.SET_STORAGE_TYPE_BY_COMPANY_ACCESS, data);
            dispatch('loadingOFF');
        } catch (error) {
            if (error.message !== 'cancelRequest')
                toast.error(i18n.t('storageType.notification.listError'), {
                    queueable: true
                });
        }
    },
    async fetchStorageTypesActiveByCompany({dispatch, commit, state}, [toast]) {
        dispatch('loadingON');
        try {
            state.storageDeviceTypesActiveByCompany = [];
            const {data} = await StorageTypesService.storageTypesActiveByCompany();
            commit(types.SET_STORAGE_TYPE_ACT_BY_COMPANY, data);
            dispatch('loadingOFF');
        } catch (error) {
            if (error.message !== 'cancelRequest')
                toast.error(i18n.t('storageType.notification.listError'), {
                    queueable: true
                });
        }
    },
    async changePositions({dispatch, commit, state}, [items, toast]) {
        dispatch('loadingON');
        try {
            await StorageTypesService.changePosition(items);
            toast.success(i18n.t('storageType.notification.save'), {
                queueable: true,
                icon: 'mdi-check-circle',
            });
        } catch (error) {
            if (error.message !== 'cancelRequest')
                toast.error(i18n.t('storageType.notification.saveError'), {
                    queueable: true
                });
        }
    },
    async activateDeactivateStorageTypes({dispatch, commit, state}, [item, editOrSave, toast]) {
        dispatch('loadingON');
        try {
            await StorageTypesService.save(item, editOrSave);
            toast.success(i18n.t('storageType.notification.save'), {
                queueable: true,
                icon: 'mdi-check-circle',
            });
        } catch (error) {
            if (error.message.includes('406')) {
                toast.error(i18n.t('storageType.notification.inUse'), {
                    queueable: true,
                    color: 'gray'
                });
            } else {
                if (error.message !== 'cancelRequest')
                    toast.error(i18n.t('storageType.notification.saveError'), {
                        queueable: true
                    });
            }
        }
    }
}
